module.exports = __webpack_public_path__ + "img/Lola-Kumtus-no-logo.689b301b.jpg";